import axios from 'axios'
import router from '../router'
import {getStorageToken} from "@/mixins/Auth.js"
import {logout} from "../mixins/Auth";
import {apiURL, memberApiURL} from "./config";


const onUnauthorized = () => {
    router.push({path: "/auth"});
};

const RESULTCODE = {
    INVALIDE_PARAMETER: "INVALID_PARAMETER",
    SUCCEEDED: "SUCCEEDED",
    ERROR: "ERROR"
}

export const setAuthInHeader = token => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
};

export const request = {
    get(path, data = null) {
        return axios.get(`${apiURL + path}`, {params: data})
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    post(path, data) {
        return axios.post(`${apiURL + path}`, data)
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || satus === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    memberGet(path, params = null) {
        return axios.get(`${memberApiURL + path}`, {params: params})
            .then(res => {
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    throw Error(res)
                } else return res;
            }).catch(({response}) => {
                if (!response) {
                    throw Error(response)
                }
                const {status} = response;
                if (status === 400 || status === 401) {
                    return onUnauthorized();
                }
                throw Error(response)
            })
    },
    memberPost(path, data) {
        return axios.post(`${memberApiURL + path}`, data)
            .then(res => {
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    this.$router.push('/auth')
                    return res;
                } else return res;
            })
            .catch(({response}) => {
                throw Error(response)
            })
    },
};

axios.interceptors.request.use(function (config) {
    if (!axios.defaults.headers.common['Authorization']) {
        let token = getStorageToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    } else {
        return config;
    }


}, function (error) {
    return Promise.reject(error);
});
